/**
 * The Changelog page as the URL holds it: which entries are listed, and
 * which one is open beside the list. Drafts are what the bare address
 * shows, so they are never written.
 */
export const CHANGELOG_TABS = ["drafts", "published"] as const
export type ChangelogTab = (typeof CHANGELOG_TABS)[number]

export type ChangelogSearch = {
  tab?: "published"
  entry?: string
}

/** Whatever the URL says, a page that can be drawn: it never throws. */
export function parseChangelogSearch(search: Record<string, unknown>): ChangelogSearch {
  const parsed: ChangelogSearch = {}
  if (search.tab === "published") parsed.tab = "published"
  // A document id, as far as its shape goes: the server says whether it is one.
  if (typeof search.entry === "string" && /^[a-z0-9]{8,64}$/i.test(search.entry)) {
    parsed.entry = search.entry
  }
  return parsed
}
